import { isSocialPlatform, Platform } from '@/types/api/platforms';

export const TooltipContent = ({
  label,
  value,
  selectedPlatform,
}: {
  label: string;
  value: number;
  selectedPlatform: Platform;
}) => {
  return (
    <div className="flex flex-col gap-2 z-[100]">
      <p className="mb-2 text-sm font-medium ">{label}</p>
      <p className="text-md font-medium text-[#4040A8]">{value}%</p>
      <p className="flex flex-col text-sm">
        <span className="text-textMedGrey ">
          {isSocialPlatform(selectedPlatform)
            ? 'of people viewing your content on ' + selectedPlatform + ' are '
            : 'of people listening to your audio podcast on Podcast Players are '}
        </span>
        <span className="text-textMedGrey font-medium">{label}</span>
      </p>
    </div>
  );
};
